import { createFeatureSelector } from '@ngrx/store';
import ICoreFeatureState, { CoreFeatureStateKey } from './core-feature-reducer';

export const selectCoreState =
  createFeatureSelector<ICoreFeatureState>(CoreFeatureStateKey);
